export default __webpack_public_path__ + "media/transfer_window/about-plus-86fb33b7.png";